import { render, staticRenderFns } from "./EditNotesModal.vue?vue&type=template&id=4cecebb4&"
import script from "./EditNotesModal.vue?vue&type=script&lang=js&"
export * from "./EditNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports